import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const ConstructionStageList = lazy(() => import('../../pages/construction_management/construction_stage/ConstructionStageList'));
const ConstructionList = lazy(() => import('../../pages/construction_management/construction/ConstructionList'));
const ConstructionDetails = lazy(() => import('../../pages/construction_management/construction/ConstructionDetails'));
const AddConstructionDailyLog = lazy(() => import('../../pages/construction_management/construction_daily_log/AddConstructionDailyLog'));
const EditConstructionDailyLog = lazy(() => import('../../pages/construction_management/construction_daily_log/EditConstructionDailyLog'));

export const ConstructionManagementImport = {
    RoutesMap,
    ConstructionStageList,
    ConstructionList,
    ConstructionDetails,
    AddConstructionDailyLog,
    EditConstructionDailyLog,
}
